import { type MutableRefObject, useState } from 'react';
import useElementSizeEffect from 'hooks/globals/useElementSizeEffect';
import type { sizes } from 'variables';

export type BreakpointObject<T> = { [key in sizes]?: T };

export const getValueFromBreakpointObject = <T>(width: number, breakpointObject: BreakpointObject<T>): T | null => {
    const matchedBreakpoint = Object.keys(breakpointObject)
        .reverse()
        .find((breakpoint) => width >= Number(breakpoint));

    if (!matchedBreakpoint) return null;
    const value = breakpointObject[matchedBreakpoint];

    return value;
};

export default function useContainerQuery<T, Y extends HTMLElement = HTMLDivElement>(
    breakpointObject: BreakpointObject<T>,
    defaultValue: T
): [MutableRefObject<Y | null>, T] {
    const [value, setValue] = useState(defaultValue);

    const [ref] = useElementSizeEffect<Y>(({ width }) => {
        if (!width) return setValue(defaultValue);

        const nextState = getValueFromBreakpointObject<T>(width, breakpointObject);

        if (!nextState) return setValue(defaultValue);

        return setValue(nextState);
    });

    return [ref, value];
}
